import { Pessoa } from "@tivic-team/manager-ts/dist/grl";
import { Agente, AitTransporte, InfracaoTransporte, Talonario } from "@tivic-team/manager-ts/dist/mob";
import { ConcessaoVeiculo } from "@tivic-team/manager-ts/dist/mob/entities/concessao/concessao-veiculo.entity";
import { TaxiParada } from "@tivic-team/manager-ts/dist/mob/entities/taxi/taxi-parada.entity";
import { TaxiPonto } from "@tivic-team/manager-ts/dist/mob/entities/taxi/taxi-ponto.entity";

export class AitTaxiDTO extends AitTransporte{

    pessoa: Pessoa = void(0);
    agente: Agente = void(0);
    talonario: Talonario = void(0);
    infracaoTransporte: InfracaoTransporte = void(0);
    concessaoVeiculo: ConcessaoVeiculo = void(0);
    taxiPonto: TaxiPonto = void(0);
    taxiParada: TaxiParada = void(0);
    nrInfracao: string = void(0);

    constructor(
        pessoa?: Pessoa,
        agente?: Agente,
        talonario?: Talonario,
        infracaoTransporte?: InfracaoTransporte,
        concessaoVeiculo?: ConcessaoVeiculo,
        taxiPonto?: TaxiPonto,
        taxiParada?: TaxiParada,
        nrInfracao?: string
    ){
        super();
        this.pessoa = pessoa;
        this.agente = agente;
        this.talonario = talonario;
        this.infracaoTransporte = infracaoTransporte;
        this.concessaoVeiculo = concessaoVeiculo;
        this.taxiPonto = taxiPonto;
        this.taxiParada = taxiParada;
        this.nrInfracao = nrInfracao;
    }
}

export class AitTaxiDTOList {
    items: Array<AitTaxiDTO>;
    total: number;

    constructor() {}
}